exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-area-default[data-v-7c269160] {\n  margin-bottom: -21px;\n}\n", ""]);

// exports
